import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Popover,
  Layout,
  Skeleton,
  Table,
  Select,
  Pagination,
  DatePicker,
  message as messageApi,
} from "antd";
import dayjs from "dayjs";
import { FaSearch, FaFilter, FaEye, FaBook } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { LESSON } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";

function CompletedLessons() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lessons, setLessons] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const recordsMessage = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getLessons();
    // eslint-disable-next-line
  }, []);

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getLessons(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };

  const handleTypeChange = (value) => {
    setFilter({
      ...filter,
      type: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getLessons(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const getLessons = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(LESSON.getCompletedLessons, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      if (response?.status) {
        setLessons(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        messageApi.error(response.message);
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="cm-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="cm-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (value, item, index) => (
        <span className="cm-index">{(index < 9 ? "0" : "") + (index + 1)}</span>
      ),
    },
    {
      title: "Lesson ID",
      dataIndex: "lessonId",
      key: "lessonId",
      render: (id) => <span className="cm-code">{id}</span>,
    },
    // {
    //   title: "Trainer/Consultant Name",
    //   dataIndex: "coach",
    //   key: "coach",
    //   render: (item) => <span>{item.firstName + " " + item.lastName}</span>,
    // },
    {
      title: "Lesson Date",
      dataIndex: "lessonDate",
      key: "lessonDate",
      render: (item) => (
        <span className="cm-meta-cell">{dayjs(item).format("M/D/YYYY")}</span>
      ),
    },
    {
      title: "Lesson Charge",
      dataIndex: "charges",
      key: "charges",
      render: (item) => <span className="cm-price">${item}</span>,
    },
    {
      title: "Lesson Type",
      dataIndex: "lessonType",
      key: "lessonType",
      render: (val) => <span className="cm-type-pill">{val}</span>,
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      width: 90,
      render: (item) => (
        <button
          type="button"
          className="cm-view-btn"
          aria-label="View lesson detail"
          onClick={() => navigate("/lesson-detail/" + item)}
        >
          <FaEye aria-hidden="true" />
        </button>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown cm-filter-popover">
      <p className="cm-filter-head">Filter lessons</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox cm-filter-select"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox cm-filter-select"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton cm-filter-apply"
          onClick={() => getLessons()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="cm-page">
      <section
        className="cm-hero"
        style={{
          backgroundImage: `url(${ImageUrl("completed-lesson.png")})`,
        }}
      >
        <div className="cm-hero-overlay" aria-hidden />
        <div className="cm-wrap cm-hero-inner">
          <div className="cm-hero-copy">
            <span className="cm-hero-badge">HISTORY</span>
            <h1 className="fontFamily1 cm-hero-title">
              Manage Completed. <span>Empower Growth.</span>
            </h1>
            <p className="fontFamily1 cm-hero-sub">
              Review past lessons by date, type, and status, or search to open a
              lesson detail quickly.
            </p>
          </div>
        </div>
      </section>

      <div className="cm-wrap cm-main">
        <div className="cm-panel">
          <div className="cm-toolbar">
            <div className="cm-toolbar-intro">
              <span className="cm-toolbar-icon" aria-hidden>
                <FaBook />
              </span>
              <h2 className="fontFamily1">Completed Lessons</h2>
            </div>
          </div>

          <div className="cm-sub-toolbar">
            <div className="cm-search-row" style={{ marginLeft: "auto" }}>
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button className="cm-filter-trigger" aria-label="Open filters">
                  <FaFilter />
                </Button>
              </Popover>
              <div className="cm-search-wrap">
                <Input
                  className="cm-search"
                  placeholder="Search lessons..."
                  value={filter.keyword}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={() =>
                    getLessons(1, paginationConfig.limit, filter.keyword)
                  }
                />
                <button
                  type="button"
                  className="cm-search-btn"
                  aria-label="Search lessons"
                  onClick={() =>
                    getLessons(1, paginationConfig.limit, filter.keyword)
                  }
                >
                  <FaSearch />
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="cm-skeleton">
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          ) : (
            <div className="cm-table-wrap">
              <Table
                className="cm-table"
                dataSource={lessons}
                columns={columns}
                pagination={false}
                rowKey={(record, index) =>
                  record._id ?? record.lessonId ?? `lesson-row-${index}`
                }
                scroll={{ x: "max-content" }}
              />
            </div>
          )}

          <div className="cm-pagination-row">
            <p className="fontFamily1 cm-pagination-meta">{recordsMessage}</p>
            <Pagination
              className="styledPagination cm-pagination"
              onChange={(e) => handlePageChange(e)}
              current={parseInt(paginationConfig.pageNumber)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default CompletedLessons;
